import type { NextRouter } from 'next/router';

import { isSameQuery } from '@/components/TransactionModule/utils';

import { fullTradeRoute, type TradeRouteState } from '@/utils/tradeRoutes';

/**
 * Navigates the homepage or a trade route to the full route for `state`.
 * Every trade route exports the same page, so the mounted trade state survives.
 */
export const navigateTradeRoute = (
  router: Pick<NextRouter, 'pathname' | 'query' | 'push' | 'replace'>,
  method: 'push' | 'replace',
  state: TradeRouteState,
) => {
  const next = fullTradeRoute(state, router.query);
  const samePage = router.pathname === next.pathname;
  if (samePage && isSameQuery(next.query, router.query)) return;
  // Shallow routing only works within the current page route.
  router[method](next, undefined, { shallow: samePage, scroll: false });
};
